import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import FeedSection from "./components/FeedSection";
import TimelineSection from "./components/TimelineSection";
import FaqSection from "./components/FaqSection";
import FooterSection from "./components/FooterSection";

export default function Home() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <HeroSection />
        <FeedSection />
        <TimelineSection />
        <FaqSection />
      </main>
      <FooterSection />
    </div>
  );
}